import { NSBox } from "./NSBox";
import { NSLink, NSLinkProps } from "./NSLink";

export function NSLinkBlue(props: NSLinkProps)
{
	return (
		<NSLink
			id={props.id}
			style=
			{{
				color: "#fff",
				border: "none",
				backgroundColor: "rgba(3, 119, 255, 1)",
				width: NSBox.width.one,
				height: NSBox.height.box,
				boxShadow: "inset 0 - 4px 4px 0px rgb(0 0 0 / 25 %)"
			}}
			title={props.title}
			href={props.href}
			target={props.target ?? "_self"}
		/>);
}